var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPascode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4842 4.8421C15.8712 4.8421 9.6842 11.0291 9.6842 18.6421C9.6842 23.2881 12.3752 27.1751 15.5032 29.8891C16.4922 30.7401 18.2172 32.0971 19.7582 34.0981C21.4602 36.3291 23.0012 38.7211 23.4842 40.3311C23.9672 38.7211 25.5082 36.3291 27.2102 34.0981C28.7512 32.0971 30.4762 30.7401 31.4652 29.8891C34.5932 27.1751 37.2842 23.2881 37.2842 18.6421C37.2842 11.0291 31.0972 4.8421 23.4842 4.8421ZM23.4842 10.7301C27.8542 10.7301 31.3962 14.2721 31.3962 18.6421C31.3962 23.0121 27.8542 26.5541 23.4842 26.5541C19.1142 26.5541 15.5722 23.0121 15.5722 18.6421C15.5722 14.2721 19.1142 10.7301 23.4842 10.7301Z",
    fill: "url(#paint0_linear_232_98)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_98",
    x1: 23.4842,
    y1: 4.8421,
    x2: 23.4842,
    y2: 40.3311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8829"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPascode);
export default __webpack_public_path__ + "static/media/pascode.66a32653546b1204a975b5cc336eb614.svg";
export { ForwardRef as ReactComponent };